export default [
  {
    uri: 'sync/assets',
    keyPath: 'externalId',
    objectStoreName: 'Assets',
    indexes: [
      'allocatedReadZone',
      'currentReadZone',
      'lastModifiedTimestamp',
      'modelNumber',
      'name',
      'parent',
      'serialNumber',
      'trackedItemType',
      'vendorName',
      'category',
      'status',
      'expirationDate',
    ],
  },
  {
    uri: 'sync/jobs',
    keyPath: 'externalId',
    objectStoreName: 'Jobs',
    indexes: ['category', 'currentReadZone', 'lastModifiedTimestamp', 'status'],
  },
]
